<template>
    <div v-loading.fullscreen.lock="fullscreenLoading" class="app-container">
      <BjPage ref="BjPage"
        :label-width="'80px'" :selection="selection"
        :query-params="queryParams" :col-span="colSpan"
        :get-action="queryApi" :serial="false"
        :before-reset-search="beforeResetSearch"
        :row-style="rowStyleFun"
        :default-sort="defaultSort"
        @showSetting="SortableTable.show"
        @handleSelectionChange="handleSelectionChange"
        @header-dragend="SortableTable.handleHeaderDragend"
        @header-contextmenu="SortableTable.handleHeaderContextmenu"
        @sort-change="sortChange"
        >
        <template v-slot:baseForm>
          <!-- 发票号 -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('billingPage.searchIDs')" prop="invoiceId">
              <BjInputNumber
                v-model="queryParams.invoiceId"
                :maxlength="MAX_LENGTH.DEFAULT"
                :placeholder="$t('billingPage.searchID')"
                clearable
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
          </el-col>
          <!-- 客户 -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('billingPage.companySeller')" prop="companyName">
              <BjSelectLov v-model="queryParams.companyName" :option-list="clientCodeList" :placeholder="$t('billingPage.companySeller')" @change="handleQuery" />
            </el-form-item>
          </el-col>
          <!-- 年-周 -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('billingPage.yearAndWeek')" prop="year">
              <el-date-picker
                id="getWeekDate"
                v-model="weekDataNow"
                :picker-options="{ firstDayOfWeek: 1 }"
                style="width: 100%"
                type="week"
                format="yyyy-WW"
                :clearable="false"
                :placeholder="$t('billingPage.yearAndWeeks')"
                @change="handleQuery"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </template>
        <template v-slot:tableOperation>
          <el-row>
            <el-col>
              <!-- <el-button type="primary" class="main-btn" @click="onFeeRecords">{{ $t('billingPage.generateFeeRecords') }}</el-button> -->
              <el-button type="primary" class="main-btn" @click="onGenerate">{{ $t('billingPage.generateLastlnvoices') }}</el-button>
              <el-button type="primary" class="main-btn" @click="onPending">{{ $t('billingPage.generatePendingBilling') }}</el-button>
              <el-button type="primary" class="main-btn" @click="onBilling">{{ $t('billingPage.generateBilling') }}</el-button>
              <el-button type="primary" class="main-btn" @click="onBatchPDF">{{ $t('billingPage.batchPDF') }}</el-button>
              <el-button type="primary" class="main-btn" @click="onBatchBreakdown">{{ $t('billingPage.batchBreakdown') }}</el-button>
              <el-button type="primary" class="main-btn" @click="onBatchRemove">{{ $t('billingPage.batchRemove') }}</el-button>
              <el-tooltip :content="$t('billingPage.generateContainerPreviewHint')" placement="top">
                <el-button type="primary" class="main-btn" :loading="containerPreviewLoading" @click="onContainerPreview">{{ $t('billingPage.generateContainerPreview') }}</el-button>
              </el-tooltip>
            </el-col>
          </el-row>
          <el-row v-if="showProgress" style="padding: 10px 5px 0;">{{ $t('billingPage.MailProgress') }}: {{ progress }}</el-row>
        </template>

        <!-- 展示列表 -->
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column v-if="!['bjTableAction', 'totalAmount'].includes(col.prop)" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
              <template slot-scope="scope">
                <template v-if="false" />
                <el-tag v-else-if="col.prop === 'invoiceReviewStatus'" :type="isReviewed(scope.row) ? 'success' : 'warning'" size="small">{{ $t(isReviewed(scope.row) ? 'invoiceReview.reviewed' : 'invoiceReview.unreviewed') }}</el-tag>
                <el-tag v-else-if="col.prop === 'state'" :type="scope.row.state == 'PAID' ? 'success' : 'info'">
                  {{ $t(BILLING_PAGE_STATUS.bjGet(scope.row.state)) }}
                </el-tag>
                <!-- <span v-else-if="col.prop === 'totalAmount'">${{ scope.row[col.prop] }}</span> -->
                <span v-else-if="col.prop === 'week'">{{ scope.row.year }}-{{ scope.row.week }}</span>
                <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
              </template>
            </el-table-column>
            <vxe-table-column v-else-if="col.prop === 'totalAmount'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="total_amount" :title="col.label" sortable width="135px">
              <template slot-scope="scope">{{ money(scope.row[col.prop]) }}</template>
            </vxe-table-column>
            <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="Math.max(Number(col.width) || 0, 180)" :fixed="col.fixed || 'right'" align="center">
              <template slot-scope="props">
                <el-tooltip v-if="canViewReview" effect="dark" :content="$t('invoiceReview.openReview')" placement="top">
                  <el-button type="text" class="edit-btn" icon="el-icon-document-checked" style="font-size: 20px;" :aria-label="$t('invoiceReview.openReview')" @click="openReview(props.row)"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="PDF" placement="top">
                  <el-button type="text" class="edit-btn" icon="el-icon-download" style="font-size: 20px;" @click="onPDF(props.row)"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="CSV" placement="top">
                  <el-button type="text" class="edit-btn" icon="el-icon-document" style="font-size: 20px;" @click="onCSV(props.row)"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="XLSX" placement="top">
                  <el-button type="text" class="edit-btn" icon="el-icon-files" style="font-size: 20px;" @click="onXLSX(props.row)"></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </template>
        </template>
      </BjPage>
    </div>
  </template>
  <script>
  import pageMiXin from '@/utils/page-mixin.js';
  import { money, reviewLocation, hasReviewPermission } from '../invoiceReview/utils';
  import { isPreviewReviewed } from '../invoiceReview/previewStatus';
  import { billApi } from '@/api';
  import { PURCHASE_TYPE_NUMBER, BILLING_PAGE_STATUS } from '@/utils/constants';
  import { getFileUrl } from '@/api/billApi';
  import axios from 'axios';
  import { VUE_APP_BILL_API } from '@/utils/index';
  import { downloadBlob } from '@/utils/index';

  export default {
    name: 'BusinessBillingPreviewInvoices',
    components: {},
    mixins: [pageMiXin],
    data() {
      return {
        PURCHASE_TYPE_NUMBER,
        BILLING_PAGE_STATUS,
        colSpan: 6,
        // 查询参数
        queryApi: billApi.getBillPreviewInvoicesList,
        queryParams: {
          invoiceId: null,
          companyName: null,
          year: null,
          // 排序字段
          sortedFields: '',
        },

        labelList: [
          { label: this.$t('invoiceReview.status'), prop: 'invoiceReviewStatus', isCheck: true, disabled: false, width: 130 },
          { label: this.$t('billingPage.companyName'), prop: 'companyName', isCheck: true, disabled: false },
          { label: this.$t('billingPage.previewInvoicesNo'), prop: 'id', isCheck: true, disabled: false },
          { label: this.$t('billingPage.sellerCode'), prop: 'clientCode', isCheck: true, disabled: false },
          { label: this.$t('billingPage.totalAmount'), prop: 'totalAmount', isCheck: true, disabled: false },
          { label: this.$t('billingPage.Week'), prop: 'week', isCheck: true, disabled: false },
          { label: this.$t('billingPage.Status'), prop: 'state', isCheck: true, disabled: false },
          { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 180 },
        ],
        weekDataNow: null,
        // 下拉搜索列表
        clientCodeList: [],
        fullscreenLoading: false,
        containerPreviewLoading: false,
        timer: null,
        progress: null,
        showProgress: false,
        // 金额排序
        defaultSort: [],
      };
    },
    computed: { canViewReview() { return hasReviewPermission(this.$store.getters.userPermissions, 'BusinessBillingInvoiceReview'); } },
    watch: {
      'weekDataNow'() {
        if (this.weekDataNow !== null) {
          this.$nextTick(() => {
            this.queryParams.year = document.querySelector('#getWeekDate').value;
          });
        }
      },
    },
    mounted() {
      // this._getSendEmailProgress()
      this.getClientInfoList();
    },
    destroyed() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
    methods: {
      money,
      isReviewed: isPreviewReviewed,
      openReview(row) { this.$router.push(reviewLocation(row)); },
      // 排序
      sortChange (column) {
        if (column.order) {
          this.defaultSort = [{ field: column.field, order: column.order }];
          this.queryParams.sortedFields = `${column.field} ${String(column.order).toUpperCase()}`;
        } else {
          this.defaultSort = [];
          this.queryParams.sortedFields = '';
        }
        this.reFresh();
      },
      // 获取所有客户信息列表
      getClientInfoList() {
        billApi.getClientInfoList().then(res => {
          res.data.forEach(item => {
            item.label = `${item.label} - ${item.value}`;
          });
          this.clientCodeList = res.data;
        });
      },
      // 下载PDF Invoice
      onPDF(item) {
        getFileUrl('downBillInvoicePDF', {id: item.id});
        // billApi.downBillInvoicePDF({id: item.id}).then((res) => {
        //   downloadBlob(res, `sellerCode_INV_number.pdf`);
        // });
      },
      // 下载CSV Invoice 压缩包
      onCSV(item) {
        getFileUrl('downBillInvoiceCsv', {id: item.id});
        // billApi.downBillInvoiceCsv({id: item.id}).then((res) => {
        //   downloadBlob(res, `CSV Invoice.zip`);
        // });
      },
      // 下载Breakdown
      onXLSX(item) {
        getFileUrl('downBillbreakdown', {id: item.id});
        // billApi.downBillbreakdown({id: item.id}).then((res) => {
        //   downloadBlob(res, `Breakdown.xlsx`);
        // });
      },
      // 生成收费记录 按钮 this.selectedRows && this.selectedRows.length == 1
      // onFeeRecords() {
      //   if (this.queryParams.companyName) {
      //     const name = this.queryParams.companyName;
      //     this.$confirm(this.$t('confirmOperationText'), this.$t('toast.hintText'), {
      //       confirmButtonText: this.$t('toast.okText'),
      //       cancelButtonText: this.$t('toast.cancelText'),
      //       type: 'warning',
      //     }).then(() => {
      //       billApi.geneBillTransaction({clientCode: name}).then(res => {
      //         this.msgSuccess(this.$t('toast.operationSuccessText'));
      //       });
      //     });
      //   } else {
      //     this.$message.warning(this.$t('billingPage.Customer'));
      //   }
      // },
      // 生成最后发票 按钮  ==> 20240805迭代 ==> 1109任务 ==>  只传clientCode 必须要选择客户
      onGenerate() {
        if (this.queryParams.companyName) {
          this.$confirm(this.$t('confirmOperationText'), this.$t('toast.hintText'), {
            confirmButtonText: this.$t('toast.okText'),
            cancelButtonText: this.$t('toast.cancelText'),
            type: 'warning',
          }).then(() => {
              console.log(this.queryParams.companyName, 'clientCode');
              billApi.geneBillLastInvoice({clientCode: this.queryParams.companyName}).then(res => {
                if (res.code == 200) {
                  this.msgSuccess(this.$t('toast.operationSuccessText'));
                  this.reFresh();
                }
              });
          });
        } else {
            this.$message.warning(this.$t('billingPage.Customer'));
        }
      },

      _getSendEmailProgress() {
        clearInterval(this.timer);
        this.timer = setInterval(() => {
          billApi.getSendEmailProgress().then(res => {
              this.showProgress = res.data.showProgress;
              this.progress = res.data.progress;
          });
        }, 1000);
      },
      // 生成待确认发票 按钮 this.selectedRows && this.selectedRows.length == 1
      onPending() {
        this.$confirm(this.$t('confirmOperationText'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        }).then(() => {
            if (this.selectedRows.length) {
              if (this.selectedRows.length == 1) {
                const invoiceId = this.selectedRows[0].id;
                billApi.geneBillPreviewInvoice({invoiceId: invoiceId}).then(() => {
                  this.msgSuccess(this.$t('toast.operationSuccessText'));
                  this.reFresh();
                });
              } else {
                this.$message.warning(this.$t('billingPage.oney'));
              }
            } else {
              if (this.queryParams.year && this.queryParams.companyName) {
                const name = this.queryParams.companyName;
                const date = this.queryParams.year;
                billApi.geneBillPreviewInvoice({clientCode: name, year: date}).then(res => {
                  if (res.code == 200) {
                    this.msgSuccess(this.$t('toast.operationSuccessText'));
                    this.reFresh();
                  }
                });
              } else {
                this.$message.warning(this.$t('billingPage.yearAndData'));
              }
            }
        });
      },
      // 生成上周的集装箱服务待确认发票
      async onContainerPreview() {
        if (this.containerPreviewLoading) return;
        this.containerPreviewLoading = true;
        try {
          await this.$confirm(this.$t('billingPage.generateContainerPreviewHint'), this.$t('toast.hintText'), {
            confirmButtonText: this.$t('toast.okText'),
            cancelButtonText: this.$t('toast.cancelText'),
            type: 'warning',
          });
          const res = await billApi.geneBillContainerPreviewInvoice();
          if (res.code == 200) {
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            this.reFresh();
          }
        } catch (error) {
          // 取消确认无需提示；接口错误由统一请求拦截器提示。
        } finally {
          this.containerPreviewLoading = false;
        }
      },
      // 生成发票 按钮 this.selectedRows && this.selectedRows.length > 0
      onBilling() {
        if (!this.selectedRows.length) { this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning')); return; }
        const invoiceIds = this.selectedRows.map(item => item.id);
        this.$confirm(this.$t('confirmOperationText'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        }).then(() => {
          this.fullscreenLoading = true;
          axios({
              method: 'post',
              url: `${VUE_APP_BILL_API()}/billing/previewInvoice/generateInvoice`,
              data: invoiceIds,
              timeout: 1000000
          }).then(() => {
            this.fullscreenLoading = false;
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            this.reFresh();
          }).catch(() => {
            this.fullscreenLoading = false;
            this.$message.error(this.$t('errorApi'));
          });
        });
      },
      // 批量下载PDF Invoice
      onBatchPDF() {
        if (!this.selectedRows.length) { this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning')); return; }
        const idList = this.selectedRows.map(e => e.id);
        billApi.downBillInvoiceBatchPDF({ids: idList}).then(res => {
          downloadBlob(res, `PDF batch.zip`);
        });
      },
      // 批量下载Breakdown
      onBatchBreakdown() {
        if (!this.selectedRows.length) { this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning')); return; }
        const idList = this.selectedRows.map(e => e.id);
        billApi.downBillInvoiceBatchBreakdown({ids: idList}).then(res => {
          downloadBlob(res, `Breakdown batch.zip`);
        });
      },
      // 批量 去掉最低消费
      onBatchRemove() {
        if (!this.selectedRows.length) { this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning')); return; }
        this.$confirm(this.$t('confirmOperationText'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        }).then(() => {
          const idList = this.selectedRows.map(e => e.id);
          billApi.removePreviewInvoice({ids: idList}).then(res => {
            if (res.code == 200) {
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              this.reFresh();
            }
          });
        });
      },
      // 标红第一份 invoice
      rowStyleFun({ row, rowIndex }) {
        const styleJson = {};
        if (row.isFirstInvoice) {
          styleJson.color = 'red';
        }
        return styleJson;
      },
      /** 重置按钮操作 */
      beforeResetSearch() {
        this.defaultSort = [];
        this.queryParams.sortedFields = '';
        this.queryParams.year = null;
        this.weekDataNow = null;
        return new Promise(resolve => {
          resolve();
        });
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  .el-icon-s-flag {
    float: right;
    line-height: 34px;
  }
  </style>
